import React from 'react';
import { useDisclosure } from '@src/core/hooks';
import { EMPTY_STRING } from '@src/core/config';
import { WeatherContext } from '@src/core/socket';
import { arcTemperature, arcVelocitas } from '@src/core/extensions';
import { useUnitType } from '@src/core/features/settings';
import { ArcCellInfo, ArcCollapse, ArcStack, ArcText } from '@src/core/ui';

const Weather: React.FC = () => {
  const { open, toggle } = useDisclosure();
  const { data } = React.useContext(WeatherContext);
  const unitType = useUnitType();

  if (!data) return null;

  const sys = data?.sys ?? {};
  const main = data?.main ?? {};
  const wind = data?.wind ?? {};
  const clouds = data?.clouds ?? {};

  const [weather] = data.weather ?? [];

  return (
    <ArcStack
      marginLeft='auto'
      sx={{ position: 'relative', width: 'fit-content', alignItems: 'flex-end' }}
    >
      <ArcStack
        pl={2}
        pr={1}
        direction='row'
        borderRadius={2}
        alignItems='center'
        justifyContent='center'
        bgcolor='background.paper'
        maxWidth='fit-content'
        sx={{ cursor: 'pointer' }}
        onClick={toggle}
      >
        <ArcText.h5> {arcTemperature(main?.temp, { fromSi: true, unitType })} </ArcText.h5>
        <ArcStack width={50} height={50}>
          <img src={`https://openweathermap.org/img/wn/${weather?.icon}@2x.png`} />
        </ArcStack>
      </ArcStack>
      <ArcCollapse
        in={open}
        sx={{
          position: 'absolute',
          top: '100%',
          right: 0,
          mt: 1,
          zIndex: 2,
          width: 'max-content',
          maxWidth: 300,
        }}
      >
        <ArcStack py={2} px={4} spacing={2} borderRadius={2} bgcolor='background.paper'>
          <ArcStack spacing={4} direction='row' justifyContent='space-between'>
            <ArcCellInfo label='COUNTRY'>
              {sys?.country ?? EMPTY_STRING}
            </ArcCellInfo>
            <ArcCellInfo label='CLOUDS'>
              {clouds?.all ?? EMPTY_STRING}%
            </ArcCellInfo>
          </ArcStack>

          <ArcStack spacing={4} direction='row' justifyContent='space-between'>
            <ArcCellInfo label='HUMIDITY'>
              {main?.humidity ?? EMPTY_STRING}%
            </ArcCellInfo>

            <ArcCellInfo label='PRESSURE'>
              {main?.pressure ?? EMPTY_STRING}hPa
            </ArcCellInfo>
          </ArcStack>

          <ArcStack spacing={4} direction='row' justifyContent='space-between'>
            <ArcCellInfo label='WIND DIRECTION'>
              {wind?.deg ?? EMPTY_STRING}°
            </ArcCellInfo>

            <ArcCellInfo label='WIND SPEED'>
              {arcVelocitas(wind?.speed, { fromSi: true, unitType })}
            </ArcCellInfo>
          </ArcStack>

        </ArcStack>
      </ArcCollapse>
    </ArcStack>
  );
};


export default Weather;
